<template>
  <VContainer fluid>
    <Loading ref="loading"></Loading>
    <FormRenderDialog ref="formRender"></FormRenderDialog>
    <VCard class="mb-5">
      <VContainer fluid grid-list-md>
        <VLayout wrap>
          <VFlex md5>
            <AutocompleteCliente
              :somente-leitura="true"
              v-model="evolucao.cliente"
            ></AutocompleteCliente>
          </VFlex>
          <VFlex md5>
            <VTextField
              readonly
              label="Serviço"
              v-model="evolucao.servico.nome"
            ></VTextField>
          </VFlex>
          <VFlex md2>
            <VTextField
              readonly
              label="Data de aquisição"
              :value="formatarData(evolucao.dataAquisicao)"
            ></VTextField>
          </VFlex>
        </VLayout>
        <VExpansionPanel expand v-model="paineis" pa-0 ma-0>
          <VExpansionPanelContent>
            <template v-slot:header
              ><VCardTitle class="title pa-0"
                >Galeria de fotos</VCardTitle
              ></template
            >
            <VContainer pa-0 ma-0>
              <VLayout>
                <GaleriaFotos
                  v-if="fotos.length"
                  :arquivos="fotos"
                  :arrayImagem="arrayImagem"
                ></GaleriaFotos>
                <VCardText v-else
                  >Nenhuma foto registrada para este tratamento.</VCardText
                >
              </VLayout>
            </VContainer>
          </VExpansionPanelContent>
        </VExpansionPanel>
        <VContainer pa-0 pt-4 ma-0>
          <VLayout>
            <VCardTitle class="title">Fichas</VCardTitle>
          </VLayout>
          <VDataTable
            :headers="cabecalhos"
            :items="evolucao.formularios"
            hide-actions
          >
            <template v-slot:items="props">
              <tr @click="$refs.formRender.visualizar(props.item.id)">
                <td>
                  {{ props.index + 1 }}
                </td>
                <td>
                  {{ formatarData(props.item.ultimaModificacao) }}
                </td>
                <td>
                  {{
                    props.item.nomeProfissional
                      ? props.item.nomeProfissional
                      : "Ninguém"
                  }}
                </td>
                <td>
                  {{ props.item.nomeFantasiaFranquia }}
                </td>
              </tr>
            </template>
          </VDataTable>
        </VContainer>
      </VContainer>
      <VFooter fixed height="auto" v-if="footer">
        <VCard flat tile class="flex">
          <VDivider />
          <VContainer grid-list-md class="py-2" fluid>
            <VLayout wrap>
              <VFlex md1>
                <VBtn small block outline @click="$router.go(-1)">Voltar</VBtn>
              </VFlex>
              <VSpacer offset-md8></VSpacer>
            </VLayout>
          </VContainer>
        </VCard>
      </VFooter>
    </VCard>
  </VContainer>
</template>

<script>
import AutocompleteCliente from "../AutocompleteCliente";
import Loading from "@/components/Dialog/Loading.vue";
import ApiService from "../../common/api.service";
import GaleriaFotos from "../Formularios/GaleriaFotos";
import datas from "@/mixins/datas";
import FormRenderDialog from "../Formularios/FormRenderDialog";

function dadosIniciais() {
  return {
    arrayImagem: [],
    paineis: [false],
    evolucao: {
      dataAquisicao: null,
      cliente: null,
      servico: {
        nome: null,
      },
      formularios: [],
    },
    cabecalhos: [
      {
        text: "Sequência",
        value: "id",
        sortable: false,
      },
      {
        text: "Última modificação",
        value: "ultimaModificacao",
        sortable: false,
      },
      {
        text: "Profissional responsável",
        value: "nomeProfissional",
        sortable: false,
      },
      {
        text: "Franquia",
        value: "nomeFantasiaFranquia",
        sortable: false,
      },
    ],
  };
}

export default {
  name: "EvolucaoTratamento.vue",
  mixins: [datas],
  components: { FormRenderDialog, AutocompleteCliente, GaleriaFotos, Loading },
  props: {
    id: {
      type: Number,
      default: null,
    },
    footer: {
      type: Boolean,
      default: true,
    },
  },
  async activated() {
    this.getEvolucao();
  },
  async deactivated() {
    Object.assign(this.$data, dadosIniciais());
  },
  data() {
    return dadosIniciais();
  },
  watch: {
    id: async function () {
      await this.getEvolucao();
    },
  },
  methods: {
    async getEvolucao() {
      if (this.id) {
        [this.evolucao] = (
          await this.$refs.loading.aguardarPromises([
            ApiService.get(`evolucao/${this.id}`)], 'Carregando')
        ).map((r) => r.data);
        this.paineis = [this.fotos.length > 0];
        this.arrayImagem = await this.getArrayImagem();
      }
    },
    async getArrayImagem(){
      var src = [];

      for (let i of this.fotos) {
        var srcAux = await ApiService.getImage(`arquivos/`, `${i.guid}?t=${i.t}&h=${i.h}`);
        src.push({ guid: i.guid, src: srcAux });
      }

      return this.fotos.map(a => ({
        src: URL.createObjectURL(src.filter(i => i.guid == a.guid)[0].src.data),
        w: a.metadados.w,
        h: a.metadados.h,
      }));
    },
  },
  computed: {
    fotos() {
      return this.evolucao.formularios.flatMap((f) =>
        f.arquivos.map((a) => ({
          ...a,
          parametros: {
            title: this.formatarDataHora(a.criacao),
          },
        }))
      );
    },
  },
};
</script>

<style scoped>
</style>
